import { CartLinesUpdateEvent } from '@shopify/events';
class WSCartUpsells extends HTMLElement {
  connectedCallback() {
    if (this.bound) return;
    this.bound = true;
    this.addEventListener('click', (event) => {
      const button = event.target.closest('[data-ws-step]');
      const track = this.querySelector('.ws-cart-slides');
      if (button && track) track.scrollBy({left: Number(button.dataset.wsStep) * track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    });
    this.addEventListener('change', (event) => {
      if (event.target.matches('select[name="id"]')) event.target.closest('article').querySelector('[data-ws-price]').textContent = event.target.selectedOptions[0].dataset.price;
    });
    this.addEventListener('submit', (event) => this.add(event));
  }
  async add(event) {
    if (!event.target.matches('[data-ws-add]')) return;
    event.preventDefault();
    if (this.busy) return;
    this.busy = true;
    const form = event.target, button = form.querySelector('button[type="submit"]'), error = this.querySelector('[role="alert"]');
    const deferred = CartLinesUpdateEvent.createPromise();
    button.disabled = true; button.textContent = 'Ajout…'; error.hidden = true;
    const data = new FormData(form);
    data.set('sections', [...new Set([...document.querySelectorAll('cart-items-component')].map(el => el.dataset.sectionId).filter(Boolean))].join(','));
    data.set('sections_url', location.pathname);
    this.dispatchEvent(new CartLinesUpdateEvent({action:'add', context:'product', lines:[{merchandiseId:String(data.get('id')),quantity:1}], promise:deferred.promise}));
    let added = false;
    try {
      const response = await fetch(form.action + '.js', {method:'POST',body:data,headers:{Accept:'application/json'}});
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || 'Impossible d’ajouter ce parfum.');
      added = true;
      const cartResponse = await fetch((window.Shopify?.routes?.root || '/') + 'cart.js', {headers:{Accept:'application/json'}});
      if (!cartResponse.ok) throw new Error('Le panier n’a pas pu être actualisé.');
      const cart = await cartResponse.json();
      deferred.resolve({cart:CartLinesUpdateEvent.createCartFromAjaxResponse(cart),detail:{source:'ws-cart-upsells',items:cart.items,sections:result.sections,didError:false}});
    } catch (e) {
      deferred.resolve({detail:{source:'ws-cart-upsells',didError:true}});
      error.textContent = added ? 'Le parfum a été ajouté. Rechargez la page pour actualiser le panier avant de continuer.' : (e.message || 'Une erreur est survenue. Réessayez.');
      error.hidden = false;
    } finally { this.busy = false; button.disabled = false; button.textContent = 'Ajouter'; }
  }
}
if (!customElements.get('ws-cart-upsells')) customElements.define('ws-cart-upsells',WSCartUpsells);
// Relie le bouton personnalisé de la fiche produit au panier Savor.
if (!window.wsProductCartConnected) {
  window.wsProductCartConnected = true;

  document.addEventListener('submit', async (event) => {
    const form = event.target;

    if (!(form instanceof HTMLFormElement)) return;
    if (!form.matches('.ws-pdp-buy__form')) return;

    const drawer = document.getElementById('cart-drawer');
    if (!drawer) return;

    event.preventDefault();

    if (form.dataset.wsAdding === 'true') return;
    form.dataset.wsAdding = 'true';

    const button = form.querySelector('[type="submit"]');
    const originalText = button?.textContent;

    let message = form.querySelector('[data-ws-cart-message]');

    if (!message) {
      message = document.createElement('p');
      message.dataset.wsCartMessage = '';
      message.setAttribute('role', 'alert');
      form.append(message);
    }

    message.hidden = true;

    if (button) {
      button.disabled = true;
      button.textContent = 'Ajout en cours…';
    }

    const data = new FormData(form);
    data.delete('return_to');

    const sectionIds = [
      ...new Set(
        [...document.querySelectorAll('cart-items-component')]
          .map((element) => element.dataset.sectionId)
          .filter(Boolean)
      ),
    ];

    data.set('sections', sectionIds.join(','));
    data.set('sections_url', location.pathname);

    const update = CartLinesUpdateEvent.createPromise();

    form.dispatchEvent(
      new CartLinesUpdateEvent({
        action: 'add',
        context: 'product',
        lines: [{
          merchandiseId: String(data.get('id')),
          quantity: Number(data.get('quantity')) || 1,
        }],
        promise: update.promise,
      })
    );

    let added = false;

    try {
      const root = window.Shopify?.routes?.root || '/';

      const response = await fetch(root + 'cart/add.js', {
        method: 'POST',
        body: data,
        headers: { Accept: 'application/json' },
      });

      const result = await response.json();

      if (!response.ok || result.status) {
        throw new Error(
          result.description || 'Impossible d’ajouter ce parfum.'
        );
      }

      added = true;

      const cartResponse = await fetch(root + 'cart.js', {
        headers: { Accept: 'application/json' },
      });

      if (!cartResponse.ok) {
        throw new Error('Actualisation du panier impossible.');
      }

      const cart = await cartResponse.json();

      update.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
        detail: {
          source: 'ws-product-button',
          items: cart.items,
          sections: result.sections,
          didError: false,
        },
      });

      await customElements.whenDefined('theme-drawer');

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          document.getElementById('cart-drawer')?.open();
        });
      });
    } catch (error) {
      update.resolve({
        detail: {
          source: 'ws-product-button',
          didError: true,
        },
      });

      message.textContent = added
        ? 'Le parfum a été ajouté. Actualisez la page pour voir votre panier.'
        : error.message || 'Une erreur est survenue. Réessayez.';

      message.hidden = false;
    } finally {
      delete form.dataset.wsAdding;

      if (button) {
        button.disabled = false;
        button.textContent = originalText;
      }
    }
  });
}